import { Button } from "@workspace/amarmeds-ds/components/ui/button";
import { Input } from "@workspace/amarmeds-ds/components/ui/input";

import { dhakaDate } from "./format";

export type Range = { from: string; to: string };

/** Today, yesterday, the last 7 or 30 days and this month (Dhaka days), or any two dates up to 93 days apart. */
export function presets(): { label: string; range: Range }[] {
  const today = dhakaDate();
  return [
    { label: "Today", range: { from: today, to: today } },
    { label: "Yesterday", range: { from: dhakaDate(-1), to: dhakaDate(-1) } },
    { label: "Last 7 days", range: { from: dhakaDate(-6), to: today } },
    { label: "Last 30 days", range: { from: dhakaDate(-29), to: today } },
    { label: "This month", range: { from: `${today.slice(0, 8)}01`, to: today } },
  ];
}

export function DateRange({ value, onChange }: { value: Range; onChange: (r: Range) => void }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {presets().map((p) => (
        <Button
          key={p.label}
          size="sm"
          variant={p.range.from === value.from && p.range.to === value.to ? "default" : "outline"}
          onClick={() => onChange(p.range)}
        >
          {p.label}
        </Button>
      ))}
      <div className="flex items-center gap-1 text-sm">
        <Input aria-label="From" type="date" className="w-40" value={value.from} max={value.to} onChange={(e) => e.target.value && onChange({ ...value, from: e.target.value })} />
        <span>to</span>
        <Input aria-label="To" type="date" className="w-40" value={value.to} min={value.from} onChange={(e) => e.target.value && onChange({ ...value, to: e.target.value })} />
      </div>
    </div>
  );
}

/** Downloads rows as a CSV file the viewer saves (Excel opens it). */
export function downloadCsv(name: string, rows: (string | number | null)[][]) {
  const cell = (v: string | number | null) => {
    const s = v === null ? "" : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const blob = new Blob(["﻿" + rows.map((r) => r.map(cell).join(",")).join("\r\n")], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
